const getDefaultFilter = () => ({
  page: 1,
  limit: 8,
  active: true,
  offset: 0,
  sort: 'nom',
  before: null,
  category: null,
  after: null,
  beforeContacts: null,
  afterContacts: null,
  contactManager: false,
  postId: null,
  portalsSelected: null,
  portalCodeNames: null,
  gratuit: null,
  sanscontacts: null,
  stock: null,
  withContacts: null,
  quota: null,
  advanced: false, // Panneau recherche avancé ouvert
  search: '', // Recherche
  preset: 'active'
})

const getPresetFilters = () => ({
  preset: 'active'
})

export default {
  namespaced: true,
  state: {
    filter: getDefaultFilter(),
    results: { total: -1, list: [] } // Stockage des derniers résultats pour accélérer le retour arrière
  },
  mutations: {
    setPage (state, page) {
      state.filter = { ...state.filter, page }
    },
    setLimit (state, limit) {
      state.filter = { ...state.filter, limit, page: 1 }
    },
    setGratuit (state, gratuit) {
      state.filter = { ...state.filter, gratuit, page: 1 }
    },
    setCategory (state, category) {
      state.filter = { ...state.filter, category, page: 1 }
    },
    setPostId (state, postId) {
      state.filter = { ...state.filter, postId, page: 1 }
    },
    setPortalsSelected (state, portalsSelected) {
      state.filter = { ...state.filter, portalsSelected, page: 1 }
    },
    setQuota (state, quota) {
      state.filter = { ...state.filter, quota, page: 1 }
    },
    setBeforeContacts (state, beforeContacts) {
      state.filter = { ...state.filter, beforeContacts, page: 1 }
    },
    setAfterContacts (state, afterContacts) {
      state.filter = { ...state.filter, afterContacts, page: 1 }
    },
    setBefore (state, before) {
      state.filter = { ...state.filter, before, page: 1 }
    },
    setAfter (state, after) {
      state.filter = { ...state.filter, after, page: 1 }
    },
    setSort (state, sort) {
      state.filter = { ...state.filter, sort, page: 1 }
    },
    setActive (state, active) {
      state.filter = { ...state.filter, active, page: 1, offset: 0 }
    },
    setSearch (state, search) {
      state.filter = { ...state.filter, search, page: 1, offset: 0 }
    },
    setOffset (state, offset) {
      state.filter = { ...state.filter, offset, page: 1 }
    },
    setStock (state, stock) {
      state.filter = { ...state.filter, stock, page: 1 }
    },
    setContactManager (state, contactManager) {
      state.filter = { ...state.filter, contactManager, page: 1 }
    },
    setPortalCodeNames (state, portalCodeNames) {
      state.filter = { ...state.filter, portalCodeNames, page: 1 }
    },
    setTotal (state, total) {
      state.results.total = total
    },
    addFilter (state, filter) {
      state.filter = { ...state.filter, ...filter, page: 1 }
    },
    setFilter (state, filter) {
      state.filter = {
        ...getDefaultFilter(),
        advanced: state.filter.advanced,
        ...filter
      }
    },
    resetFilter (state) {
      state.filter = getDefaultFilter()
      state.results = { total: -1, list: [] }
    },
    resetPresetFilters (state) {
      state.filter = {
        ...getDefaultFilter(),
        advanced: state.filter.advanced,
        ...getPresetFilters()
      }
    },
    setResults (state, results) {
      state.results = results
    }
  }
}
